import '../css/aboutContainer.css'

const AboutContainer = () => {
    return (
        <div className="about-cont">
            <div className="about-head-para">
                <h1 className="about-head">About TTU MSA</h1>
                <p className="about-para">Salam Alaikum! Welcome to the Muslim Students Association (MSA) at
          Texas Tech University! Our main goal is to bring people together—whether through
          fun social events, thought-provoking discussions, or community service
          projects.We work hard to build connections, help each other grow, and give
              back to our campus and the local community. Whether you’re here to
              meet new friends, learn more about the Islamic faith, or just want
              to be part of something meaningful, the MSA is for you. Join us as
              we celebrate diversity, build lasting friendships, and make a
              positive difference on and off campus. We’d love to have you be
              part of our journey—come see what we’re all about!</p>
            </div>
        </div>
    )
}

export default AboutContainer;